// @flow
import React, { Component } from 'react';

class NotFound extends Component {
  render() {
    return (
      <div>
        <div className="full-page bg-light text-light pv3">
          <div className="inner">
            <h1>
              Not Found
            </h1>
          </div>
        </div>
      </div>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/pages/NotFound/index.jsx